function OVComponent(component) {
  return (constructor) => {
    component = component || constructor.name;
    objectview.OVComponent[component] = constructor;
  };
}
function OBVComponent(component) {
  return (constructor) => {
    component = component || constructor.name;
    objectview.OBVComponent[component] = constructor;
  };
}
function OAVComponent(component) {
  return (constructor) => {
    component = component || constructor.name;
    objectview.OAVComponent[component] = constructor;
  };
}
function ov(param) {
  return (constructor) => {
    if (!Object.getOwnPropertyDescriptor(constructor.prototype, objectviewKey)) {
      constructor.prototype[objectviewKey] = {};
    }
    const objectview2 = constructor.prototype[objectviewKey];
    objectview2.component = param.component;
    objectview2.componentParam = param.componentParam;
  };
}
function oav(param) {
  return (target, propertyKey) => {
    objectview.addOAV(target, propertyKey, param);
  };
}
class ObjectView {
  constructor() {
    this.defaultBaseObjectViewClass = "";
    this.defaultObjectViewClass = "";
    this.defaultObjectAttributeViewClass = "";
    this.defaultObjectAttributeBlockView = "";
    this.defaultTypeAttributeView = {};
    this.OAVComponent = {};
    this.OBVComponent = {};
    this.OVComponent = {};
  }
  setDefaultTypeAttributeView(type, component) {
    this.defaultTypeAttributeView[type] = component;
  }
  /**
   * 获取对象界面
   * @param object 用于生成界面的对象
   * @param param 参数
   */
  getObjectView(object, param) {
    const p = { autocreate: true, excludeAttrs: [] };
    Object.assign(p, param);
    const classConfig = this.getObjectInfo(object, p.autocreate, p.excludeAttrs);
    classConfig.editable = classConfig.editable === void 0 ? true : classConfig.editable;
    Object.assign(classConfig, param);
    classConfig.objectAttributeInfos = classConfig.objectAttributeInfos.filter((v) => !v.exclude);
    classConfig.objectBlockInfos.forEach((v) => {
      v.itemList = v.itemList.filter((vv) => !vv.exclude);
    });
    classConfig.objectAttributeInfos.forEach((v) => {
      v.editable = v.editable && classConfig.editable;
    });
    if (objectIsEmpty(classConfig.component) || classConfig.component === "") {
      if (!(classConfig.owner instanceof Object)) {
        classConfig.component = this.defaultBaseObjectViewClass;
      } else {
        classConfig.component = this.defaultObjectViewClass;
      }
    }
    const Cls = this.OVComponent[classConfig.component];
    console.assert(!!Cls, `没有定义 ${classConfig.component} 对应的对象界面类，需要在 ${classConfig.component} 中使用@OVComponent()标记`);
    const view = new Cls(classConfig);
    return view;
  }
  /**
   * 获取属性界面
   *
   * @static
   * @param attributeViewInfo 属性界面信息
   * @returns                        属性界面
   *
   * @memberOf ObjectView
   */
  getAttributeView(attributeViewInfo) {
    if (objectIsEmpty(attributeViewInfo.component) || attributeViewInfo.component === "") {
      const defaultViewClass = this.defaultTypeAttributeView[attributeViewInfo.type];
      const tempComponent = defaultViewClass ? defaultViewClass.component : "";
      if (tempComponent !== null && tempComponent !== "") {
        attributeViewInfo.component = defaultViewClass.component;
        attributeViewInfo.componentParam = defaultViewClass.componentParam || attributeViewInfo.componentParam;
      }
    }
    if (objectIsEmpty(attributeViewInfo.component) || attributeViewInfo.component === "") {
      attributeViewInfo.component = this.defaultObjectAttributeViewClass;
    }
    const Cls = this.OAVComponent[attributeViewInfo.component];
    console.assert(Cls !== null, `没有定义 ${attributeViewInfo.component} 对应的属性界面类，需要在 ${attributeViewInfo.component} 中使用@OVAComponent()标记`);
    const view = new Cls(attributeViewInfo);
    return view;
  }
  /**
   * 获取块界面
   *
   * @static
   * @param blockViewInfo 块界面信息
   * @returns                块界面
   *
   * @memberOf ObjectView
   */
  getBlockView(blockViewInfo) {
    if (objectIsEmpty(blockViewInfo.component) || blockViewInfo.component === "") {
      blockViewInfo.component = this.defaultObjectAttributeBlockView;
    }
    const Cls = this.OBVComponent[blockViewInfo.component];
    console.assert(Cls !== null, `没有定义 ${blockViewInfo.component} 对应的块界面类，需要在 ${blockViewInfo.component} 中使用@OVBComponent()标记`);
    const view = new Cls(blockViewInfo);
    return view;
  }
  addOAV(target, propertyKey, param) {
    if (!Object.getOwnPropertyDescriptor(target, objectviewKey)) {
      target[objectviewKey] = {};
    }
    const objectview2 = target[objectviewKey] || {};
    const attributeDefinitionVec = objectview2.attributeDefinitionVec = objectview2.attributeDefinitionVec || [];
    const attributeDefinition = Object.assign({ name: propertyKey }, param);
    attributeDefinitionVec.push(attributeDefinition);
  }
  /**
   * 获取对象信息
   * @param object 对象
   * @param autocreate 当对象没有注册属性时是否自动创建属性信息
   * @param excludeAttrs 排除属性列表
   * @return
   */
  getObjectInfo(object, autocreate = true, excludeAttrs = []) {
    if (typeof object === "string" || typeof object === "number" || typeof object === "boolean") {
      return {
        objectAttributeInfos: [],
        objectBlockInfos: [],
        owner: object,
        component: "",
        componentParam: void 0
      };
    }
    let classConfig = getInheritClassDefinition(object, autocreate);
    classConfig = classConfig || {
      component: "",
      componentParam: null,
      attributeDefinitionVec: [],
      blockDefinitionVec: []
    };
    const objectAttributeInfos = [];
    classConfig.attributeDefinitionVec.forEach((attributeDefinition) => {
      if (excludeAttrs.indexOf(attributeDefinition.name) === -1) {
        let editable = attributeDefinition.editable === void 0 ? true : attributeDefinition.editable;
        editable = editable && propertyIsWritable(object, attributeDefinition.name);
        const obj = { owner: object, type: getAttributeType(object[attributeDefinition.name]) };
        Object.assign(obj, attributeDefinition);
        obj.editable = editable;
        objectAttributeInfos.push(obj);
      }
    });
    function getAttributeType(attribute) {
      if (objectIsEmpty(attribute)) {
        return "null";
      }
      if (typeof attribute === "number") {
        return "number";
      }
      return attribute.constructor.name;
    }
    objectAttributeInfos.forEach((v, i) => {
      v[tempIKey] = i;
    });
    objectAttributeInfos.sort((a, b) => (a.priority || 0) - (b.priority || 0) || a[tempIKey] - b[tempIKey]);
    objectAttributeInfos.forEach((v, _i) => {
      delete v[tempIKey];
    });
    const objectInfo = {
      objectAttributeInfos,
      objectBlockInfos: getObjectBlockInfos(object, objectAttributeInfos, classConfig.blockDefinitionVec),
      owner: object,
      component: classConfig.component,
      componentParam: classConfig.componentParam
    };
    return objectInfo;
  }
}
const objectview = new ObjectView();
function mergeClassDefinition(oldClassDefinition, newClassDefinition) {
  if (newClassDefinition.component && newClassDefinition.component.length > 0) {
    oldClassDefinition.component = newClassDefinition.component;
    oldClassDefinition.componentParam = newClassDefinition.componentParam;
  }
  oldClassDefinition.attributeDefinitionVec = oldClassDefinition.attributeDefinitionVec || [];
  if (newClassDefinition.attributeDefinitionVec && newClassDefinition.attributeDefinitionVec.length > 0) {
    newClassDefinition.attributeDefinitionVec.forEach((newAttributeDefinition) => {
      let isfound = false;
      oldClassDefinition.attributeDefinitionVec.forEach((oldAttributeDefinition) => {
        if (newAttributeDefinition && oldAttributeDefinition.name === newAttributeDefinition.name) {
          Object.assign(oldAttributeDefinition, newAttributeDefinition);
          const oldIndex = oldClassDefinition.attributeDefinitionVec.indexOf(oldAttributeDefinition);
          oldClassDefinition.attributeDefinitionVec.splice(oldIndex, 1);
          oldClassDefinition.attributeDefinitionVec.push(oldAttributeDefinition);
          isfound = true;
        }
      });
      if (!isfound) {
        const attributeDefinition = {};
        Object.assign(attributeDefinition, newAttributeDefinition);
        oldClassDefinition.attributeDefinitionVec.push(attributeDefinition);
      }
    });
  }
  oldClassDefinition.blockDefinitionVec = oldClassDefinition.blockDefinitionVec || [];
  if (newClassDefinition.blockDefinitionVec && newClassDefinition.blockDefinitionVec.length > 0) {
    newClassDefinition.blockDefinitionVec.forEach((newBlockDefinition) => {
      let isfound = false;
      oldClassDefinition.blockDefinitionVec.forEach((oldBlockDefinition) => {
        if (newBlockDefinition && newBlockDefinition.name === oldBlockDefinition.name) {
          Object.assign(oldBlockDefinition, newBlockDefinition);
          isfound = true;
        }
      });
      if (!isfound) {
        const blockDefinition = {};
        Object.assign(blockDefinition, newBlockDefinition);
        oldClassDefinition.blockDefinitionVec.push(blockDefinition);
      }
    });
  }
}
function getInheritClassDefinition(object, autocreate = true) {
  const classConfigVec = [];
  let prototype = object;
  while (prototype) {
    const classConfig = prototype[objectviewKey];
    if (classConfig) {
      classConfigVec.push(classConfig);
    }
    prototype = prototype[protoKey];
  }
  let resultclassConfig;
  if (classConfigVec.length > 0) {
    resultclassConfig = {};
    for (let i = classConfigVec.length - 1; i >= 0; i--) {
      mergeClassDefinition(resultclassConfig, classConfigVec[i]);
    }
  } else if (autocreate) {
    resultclassConfig = getDefaultClassConfig(object);
  }
  return resultclassConfig;
}
function getDefaultClassConfig(object, filterReg = /(([a-zA-Z0-9])+|(\d+))/) {
  let attributeNames = [];
  for (const key in object) {
    const result = filterReg.exec(key);
    if (result && result[0] === key) {
      const value = object[key];
      if (value === void 0 || value instanceof Function) {
        continue;
      }
      attributeNames.push(key);
    }
  }
  attributeNames = attributeNames.sort();
  const attributeDefinitionVec = [];
  attributeNames.forEach((element) => {
    attributeDefinitionVec.push({
      name: element,
      block: ""
    });
  });
  const defaultClassConfig = {
    component: "",
    attributeDefinitionVec,
    blockDefinitionVec: []
  };
  return defaultClassConfig;
}
function getObjectBlockInfos(object, objectAttributeInfos, blockDefinitionVec) {
  const objectBlockInfos = [];
  const dic = {};
  let objectBlockInfo;
  let i = 0;
  const tempVec = [];
  for (i = 0; i < objectAttributeInfos.length; i++) {
    const blockName = objectAttributeInfos[i].block || "";
    objectBlockInfo = dic[blockName];
    if (objectIsEmpty(objectBlockInfo)) {
      objectBlockInfo = dic[blockName] = { name: blockName, owner: object, itemList: [] };
      tempVec.push(objectBlockInfo);
    }
    objectBlockInfo.itemList.push(objectAttributeInfos[i]);
  }
  let blockDefinition;
  const pushDic = {};
  if (blockDefinitionVec) {
    for (i = 0; i < blockDefinitionVec.length; i++) {
      blockDefinition = blockDefinitionVec[i];
      objectBlockInfo = dic[blockDefinition.name];
      if (objectIsEmpty(objectBlockInfo)) {
        objectBlockInfo = {
          name: blockDefinition.name,
          owner: object,
          itemList: []
        };
      }
      objectBlockInfo.component = blockDefinition.component;
      objectBlockInfo.componentParam = blockDefinition.componentParam;
      objectBlockInfos.push(objectBlockInfo);
      pushDic[objectBlockInfo.name] = true;
    }
  }
  for (i = 0; i < tempVec.length; i++) {
    if (Boolean(pushDic[tempVec[i].name]) === false) {
      objectBlockInfos.push(tempVec[i]);
    }
  }
  return objectBlockInfos;
}
function propertyIsWritable(obj, property) {
  const data = getPropertyDescriptor(obj, property);
  if (!data)
    return false;
  if (data.get && !data.set)
    return false;
  return true;
}
function getPropertyDescriptor(object, property) {
  const data = Object.getOwnPropertyDescriptor(object, property);
  if (data) {
    return data;
  }
  const prototype = Object.getPrototypeOf(object);
  if (prototype) {
    return getPropertyDescriptor(prototype, property);
  }
  return void 0;
}
const tempIKey = "___tempI";
const protoKey = "__proto__";
const objectviewKey = "__objectview__";
function objectIsEmpty(obj) {
  if (obj === void 0 || obj === null) {
    return true;
  }
  return false;
}
export {
  OAVComponent,
  OBVComponent,
  OVComponent,
  ObjectView,
  oav,
  objectview,
  ov
};
//# sourceMappingURL=index.js.map
